/**
 * @generated SignedSource<<e33b47254d7a0a9e67f65e8d5e8e19c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignUpInput_participant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortId",
      "storageKey": null
    },
    {
      "alias": "contact",
      "args": null,
      "concreteType": "Contact",
      "kind": "LinkedField",
      "name": "contactByContactId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "conversation",
      "args": null,
      "concreteType": "Conversation",
      "kind": "LinkedField",
      "name": "conversationByConversationId",
      "plural": false,
      "selections": [
        {
          "alias": "userParticipants",
          "args": null,
          "concreteType": "ParticipantsConnection",
          "kind": "LinkedField",
          "name": "participantsByConversationId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ParticipantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Participant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": "user",
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "userByUserId",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": "family",
                      "args": null,
                      "concreteType": "Family",
                      "kind": "LinkedField",
                      "name": "familyByFamilyId",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Participant",
  "abstractKey": null
};

node.hash = "fa5cccfacb44e210634dc8e7a34a5600";

module.exports = node;
